/* built from src/js/dw-shoplift.js - edit the source, not this file */
const setHypothesis=t=>{const i=setInterval(()=>{window.updateCart&&(clearInterval(i),window.updateCart({method:"POST",headers:{"Content-Type":"application/json",Accept:"application/json"},body:JSON.stringify({attributes:{_ab_shipping:t?"1":""}})}))},100)},resizeIconsWithText=()=>{const n=setInterval(()=>{document.querySelectorAll(".icons-with-text gridy-slider").forEach(i=>{clearInterval(n),!(i.querySelectorAll(".gridy-track > div").length>3)&&(i.dataset.iprDesktop=i.dataset.iprDesktop-1,i.dataset.iprTablet=i.dataset.iprTablet-1,Number(i.dataset.iprDesktop)<3&&(i.querySelector(".gridy-track").classList.remove("md-grid-cols-3"),i.querySelector(".gridy-track").classList.add("md-grid-cols-2")))})},100)};if(window.shoplift){const t=["019e4e75-c85f-7d3b-86cd-67245fccca8e","019e4e88-5882-7852-8f84-4e7be06c733f","019e4e8a-3fe6-76d9-b2d4-ebfb0627a3f7","019e447b-9ff2-7adb-ad29-ef2232b830e5","019e4e83-b0ac-7819-a32b-128653bdbbf8"];Promise.all(t.map(n=>window.shoplift.isHypothesisActive(n))).then(n=>{n.some(e=>e)?(restyle(),setHypothesis(!0)):setHypothesis(!1)})}else setHypothesis(!1);const restyle=()=>{const t=document.createElement("style");window.Shopify.shop==="daniel-wellington-eu.myshopify.com"?(t.innerHTML=`
      .icons-with-text .gridy-track > div:nth-child(1) {
        display: none !important;
      }
      .icons-with-text gridy-slider {
        opacity: 0;
      }
      .section-in-view .icons-with-text gridy-slider.gridy-slider {
        transition: opacity 0.6s ease-in;
        opacity: 1;
      }
      .pdp-usp-container .pdp-usp:nth-child(1) {
        display: none !important;
      }
      .shipping-method-row__price {
        display: none !important;
      }
      #cart-shipping-notification {
        display: none !important;
      }
    `,resizeIconsWithText()):window.Shopify.shop==="daniel-wellington-south-africa.myshopify.com"?(t.innerHTML=`
      .icons-with-text .gridy-track > div:nth-child(1) {
        display: none !important;
      }
      .icons-with-text gridy-slider {
        opacity: 0;
      }
      .section-in-view .icons-with-text gridy-slider.gridy-slider {
        transition: opacity 0.6s ease-in;
        opacity: 1;
      }
      .shipping-method-row__price {
        display: none !important;
      }
      #cart-shipping-notification {
        display: none !important;
      }
      html[lang="en"] .product__tax {
        font-size: 0 !important;
      }
      html[lang="en"] .product__tax:after {
        content: "Tax included." !important;
        font-size: 8px !important;
      }
    `,resizeIconsWithText()):window.Shopify.shop==="daniel-wellington-japan.myshopify.com"?t.innerHTML=`
      .shipping-method-row__price {
        display: none !important;
      }
      #cart-shipping-notification {
        display: none !important;
      }
    `:window.Shopify.shop==="daniel-wellington-australia.myshopify.com"&&(t.innerHTML=`
      .icons-with-text .gridy-track > div:nth-child(1) {
        display: none !important;
      }
      .icons-with-text gridy-slider {
        opacity: 0;
      }
      .section-in-view .icons-with-text gridy-slider.gridy-slider {
        transition: opacity 0.6s ease-in;
        opacity: 1;
      }
      .shipping-method-row__price {
        display: none !important;
      }
      #cart-shipping-notification {
        display: none !important;
      }
      html[lang="en"] .product__tax {
        font-size: 0 !important;
      }
      html[lang="en"] .product__tax:after {
        content: "Tax included." !important;
        font-size: 10px !important;
        margin-left: -4px;
      }
    `,resizeIconsWithText()),document.head.appendChild(t)};
